import styled from 'styled-components';
import {Link} from "react-router-dom";

export const Fitgroupinner = styled.div `
    // padding-bottom: calc(100vw*(120/375));
`
export const Modal = styled.div`
    position: fixed;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    width: calc(100vw*(284/375));
    border-radius: calc(100vw*(10/375));
    background-color: #ffffff;
    z-index: 500;
`
export const ModalTitle = styled.h3`
    font-size: calc(100vw*(18/375));
    font-weight: bold;
    letter-spacing: 0.25px;
    text-align: center;
    padding: calc(100vw*(20/375)) 0 calc(100vw*(12/375)) 0;
`
export const ModalContentInner = styled.p`
    text-align: center;
    font-size: calc(100vw*(14/375));
    line-height: 1.43;
    letter-spacing: 0.2px;
    padding-bottom: calc(100vw*(16.5/375));
`

export const ModalBg = styled.div`
    position: fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.6);
    z-index: 400;
`

export const ModalButtonInner = styled.div`
    width: 100%;
    height: calc(100vw*(44/375));
    border-top: calc(100vw*(1/375)) solid #c6c6c6;
`
export const ModalBtn = styled(Link)`
    width:50%;
    height:100%;
    font-size: calc(100vw*(16/375));
    font-weight: bold;
    line-height: calc(100vw*(43/375));
    text-align: center;
    color: #008aff;
`
export const ModalCancelBtn = styled.span`
    width:50%;
    height:100%;
    font-size: calc(100vw*(16/375));
    font-weight: bold;
    line-height: calc(100vw*(43/375));
    text-align: center;
    color: #008aff;
`